"use strict";

exports.__esModule = true;
exports["default"] = exports.GoogleMapsProvider = exports.GoogleMapsContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _commonLibs = require("@mmc/common-libs");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var GoogleMapsContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.GoogleMapsContext = GoogleMapsContext;
var GoogleMapsProvider = function GoogleMapsProvider(_ref) {
  var children = _ref.children,
    apiKey = _ref.apiKey;
  var _useState = (0, _react.useState)(null),
    mapsApi = _useState[0],
    setMapsApi = _useState[1];
  (0, _react.useEffect)(function () {
    (0, _commonLibs.loadScript)({
      google: (0, _commonLibs.getGoogleApiURL)({
        apiKey: apiKey,
        libraries: ['places', 'geometry']
      })
    }).google.onLoad(function () {
      setMapsApi(window.google);
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(GoogleMapsContext.Provider, {
    value: {
      mapsApi: mapsApi
    }
  }, children);
};
exports.GoogleMapsProvider = GoogleMapsProvider;
var useGoogleMaps = function useGoogleMaps() {
  return (0, _react.useContext)(GoogleMapsContext);
};
var _default = useGoogleMaps;
exports["default"] = _default;